<template>
  <div v-if="series.length > 0" class="chart-container h-100 w-100 d-flex align-items-center justify-content-center">
    <apexchart type="polarArea" :height="chartHeight" :options="chartOptions" :series="series"/>
  </div>
</template>

<script>
export default {
  name: 'OfficeBasedPolarChart',
  props: ['chartData', 'chartHeight', 'companyPrimaryColor'],
  computed: {
    sortedData() {
      const known = this.chartData.filter(item => item.work_mode !== 'Unknown')
      const unknown = this.chartData.filter(item => item.work_mode === 'Unknown')
      return [...known.sort((a, b) => b.headcount - a.headcount), ...unknown]
    },
    series() {    
      return this.sortedData.map(item => item.headcount)
    },
    chartOptions() {
      return {
        chart: {
          type: 'polarArea',
          fontFamily: 'Manrope, Arial, sans-serif'
        },
        labels: this.sortedData.map(item => item.work_mode),       
        theme: {
          monochrome: {
            enabled: true,
            shadeTo: 'light',
            shadeIntensity: 0.8,            
            color: this.companyPrimaryColor,
          }
        },
        legend: {
          position: 'right',
          horizontalAlign: 'center'
        },
        stroke: {
          colors: ['#fff']
        },
        fill: {
          opacity: 0.8
        },
        dataLabels: {
          enabled: true,
          formatter: function(val, opts) {
            return opts.w.config.series[opts.seriesIndex];
          }
        },
        yaxis: {
          show: false
        },        
        tooltip: {
          y: { formatter: val => `${val} employees` }
        }        
      }
    }
  }
}
</script>